import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed, useContext } from '@nuxtjs/composition-api';
import ResourceContributors from './ResourceContributors.vue';
import { State } from '~/store';
import VocabList from '~/components/resource/VocabList.vue';
import DownloadLink from '~/components/resource/DownloadLink.vue';
import CurriculumList from '~/components/resource/CurriculumList.vue';
import { Resource } from '~/types/resource';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceFooter',
  props: {
    resource: null
  },
  setup(__props: any) {

const { $isFlagOn } = useContext();
const store = useStore<State>();
const isAuthenticated = computed(() => store.getters.isAuthenticated);



return { __sfc: true,$isFlagOn, store, isAuthenticated, ResourceContributors, VocabList, DownloadLink, CurriculumList }
}

})